<div class="card-container" [ngClass]="{'selected-card' : isSelected , 'not-selected-card': !isSelected}">
    <!-- Container -->
    <div class="d-flex justify-self-start" [style.padding-left]="isSelected ? '4px' :'16px'">
        <!-- Badge -->
        <div class="card-badge-image" >
             <!-- Selected card check -->
                <svg class="selected-check" *ngIf="isSelected">
                    <use href="../App_Themes/CXone/icons/gamification/cxone-check.svg#cxone-check">
                    </use>
                </svg>
                    <img [src]="'../Admin/ImageResizer.aspx?imgid=' + badgeImage + '&w=48&h=48'" cvImageFallback
                    [svgIcon]="'../App_Themes/CXone/icons/gamification/award-fallback.svg#award-fallback'"
                    [svgClass]="'fallback-img'">                
         </div>
         <!-- Content -->
          <div class="d-inline justify-content-start pl-2">
            <!-- Title -->
            <div class="d-flex" >
                <span class="card-text-bold pb-1">{{awardName}}</span>
            </div>
            <!-- Coins -->
            <div *ngIf="coins > 0">
                <div class="d-flex justify-self-start">
                    <svg class="awards-coins-icon">
                        <use href="../App_Themes/CXone/icons/gamification/coin.svg#coin">
                        </use>
                    </svg>
                    <span class="coin-title" cvLocalizedText langSection="Manual_Awards" langKey="Coin">Coin</span>
                    <span class="coin-title">:</span>
                    <span 
                        class="pl-1 coin-text"
                        #truncateElement
                        [tooltip]="checkTruncation(truncateElement) && (coins | cvNumberLocalize)">
                        {{coins |cvNumberLocalize}}
                    </span>
                </div>
            </div>
          </div>
      </div>
</div>